import loadable from '@utils/loadable';

import withMetatag from '../../decorators/metadataDecorators/metatagsTitleDecorator';

import Preloader from '../../components/Preloader';

const PricingClient = loadable(
  () => import('../../components/PricingComponents/PricingClient'),
  { fallback: <div style={{ height: '100vh' }}><Preloader loading /></div> },
);

export const Pricing = (props) => (
  <PricingClient {...props} />
);

export default withMetatag(Pricing, 'pricing');
